export const VEHICLE_TYPE_OPTIONS = [
  { value: 'carro', label: 'Carro' },
  { value: 'moto', label: 'Moto' },
  { value: 'caminhao', label: 'Caminhão' },
  { value: 'outro', label: 'Outro' },
];

export const VEHICLE_TYPE_TRANSLATIONS: Record<string, string> = {
  carro: 'Carro',
  moto: 'Moto',
  caminhao: 'Caminhão',
  outro: 'Outro',
};

export const initialValues = {
  marca: '',
  modelo: '',
  tipo: '',
  placa: '',
  ano: new Date().getFullYear(),
  cor: '',
  observacoes: '',
  foto: undefined,
  tenant_id: '',
}; 